import { useContributions } from "@/hooks/use-contributions";
import { useToast } from "@/components/ui/toast";
import { useAppContext } from "@/providers";
import { t } from "@/lib/i18n/messages";
import { ContributionRequestsTable } from "@/components/contributions/contribution-requests-table";
import { MyContributionsTable } from "@/components/contributions/my-contributions-table";

export default function ContributionsPage() {
  const { locale } = useAppContext();
  const { toast } = useToast();
  const {
    requests,
    requestsLoading,
    contributions,
    contributionsLoading,
    contributionsMeta,
    actionLoading,
    direction,
    setDirection,
    setRequestStatus,
    setRequestSearch,
    setContributionStatus,
    setContributionSearch,
    contributionPage,
    setContributionPage,
    acceptRequest,
    rejectRequest,
  } = useContributions();

  async function handleAccept(id: number) {
    const success = await acceptRequest(id);
    if (success) {
      toast(t(locale, "statusAccepted"), "success");
    } else {
      toast(t(locale, "errorLoadingData"), "error");
    }
  }

  async function handleReject(id: number) {
    const success = await rejectRequest(id);
    if (success) {
      toast(t(locale, "statusRejected"), "success");
    } else {
      toast(t(locale, "errorLoadingData"), "error");
    }
  }

  function handleShowMore() {
    setContributionPage(contributionPage + 1);
  }

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto space-y-8">
      <ContributionRequestsTable
        requests={requests}
        direction={direction}
        onDirectionChange={setDirection}
        onSearch={setRequestSearch}
        onStatusFilter={setRequestStatus}
        onAccept={handleAccept}
        onReject={handleReject}
        loading={requestsLoading}
        actionLoading={actionLoading}
      />
      <MyContributionsTable
        contributions={contributions}
        onSearch={setContributionSearch}
        onStatusFilter={setContributionStatus}
        onShowMore={handleShowMore}
        hasMore={contributionsMeta?.hasMore ?? false}
        loading={contributionsLoading}
      />
    </div>
  );
}
